import { render } from "./ContestantProfilePay.vue?vue&type=template&id=4f95c6ac&scoped=true"
import script from "./ContestantProfilePay.vue?vue&type=script&lang=js"
export * from "./ContestantProfilePay.vue?vue&type=script&lang=js"

import "./ContestantProfilePay.vue?vue&type=style&index=0&id=4f95c6ac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f95c6ac"]])

export default __exports__